import { useTranslate } from '@festina-life/ui/hooks'
import { Popover, PopoverButton } from '@festina-life/ui/structure'

import { useRequiredWorkspaceOperationsContext } from '../../../../workspace/operationsContext'
import { ActionsMenuPanel } from '../../../actionsPanel/ActionsMenuPanel'
import { OperationsLoadedButton } from '../../../operationsButton/OperationsLoadedButton'
import { DownloadWorkspacePanel } from './DownloadWorkspacePanel'
import { useDownloadWorkspacePackage } from './useDownloadWorkspacePackage'

export const DownloadWorkspaceButton = () => {
  const translate = useTranslate()
  const { workspaceKey } = useRequiredWorkspaceOperationsContext()
  const { hasOperations } = useDownloadWorkspacePackage(workspaceKey)

  return (
    <Popover>
      <PopoverButton as="div">
        <OperationsLoadedButton
          startIcon="ArrowDownTray"
          disabled={!hasOperations}
        >
          {translate('workspaceDetailsPanel.tabs.manage.downloadPackage')}
        </OperationsLoadedButton>
      </PopoverButton>
      <ActionsMenuPanel anchor={{ to: 'right' }}>
        <DownloadWorkspacePanel workspaceKey={workspaceKey} />
      </ActionsMenuPanel>
    </Popover>
  )
}
